<div class="content">

	<div class="container-fluid">
		<!--  -->
		<div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
		<div class="col-md-6 col-sm-6 col-xs-6 col-lg-6 " >
	    <mat-card class="apimanagerresultpanel" >
	    <h4>Api Mapping</h4>
			<form [formGroup]="apiMapping" (ngSubmit)="apiMappingSubmit()"
				class="example-container" style="height: 71vh;

Overflow: auto;">
				<div>
					<div class="row"  formArrayName="apiStatic">

					<div *ngFor="let static of apiStaticAttribue; let i=index" >

						<div [formGroupName]="i" >
							<!--  -->
							<div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">

								<div class="col-md-6 col-sm-12 col-xs-12 col-lg-6">
									<div class="col" fxLayout="row" fxLayout.xs="column"
										fxLayoutWrap fxLayoutGap="3.5%" fxLayoutAlign="center">
										<!-- unit name input field -->
										<mat-form-field appearance="outline"
											style="width:100%;padding-right: 10px"> <input
											matInput placeholder="" formControlName="attributeName"
											readonly> </mat-form-field>
									</div>
								</div>

								<div class="col-md-6 col-sm-12 col-xs-12 col-lg-6">
								
									<div fxLayout="row" fxLayout.xs="column" fxLayoutWrap
										fxLayoutGap="3.5%" fxLayoutAlign="center">
										<mat-form-field  appearance="outline"
											style="width:100%;padding-right: 10px"> <mat-label>Mapping
										Attribute</mat-label> <mat-select multiple disableRipple
											formControlName="attributeMap"> 
											
											<!--Filter Start  -->
										<!-- <mat-select-search
										autocomplete="off"
										[formControl]="DynamicAttribueMultiFilterCtrl">
									</mat-select-search>  --> <!--  <input matInput
										class="mat-select-search-input" #searchSelectInput
										(keydown)="_handleKeydown($event)"
										(input)="onInputChange($event.target.value)"
										(blur)="onBlur($event.target.value)"
										[placeholder]="placeholderLabel"
										[formControl]="DynamicAttribueMultiFilterCtrl">

									<button mat-button *ngIf="value" mat-icon-button
										aria-label="Clear" (click)="_reset(true)"
										class="mat-select-search-clear">
										<mat-icon>close</mat-icon>
									</button> --> <!-- <div
										*ngIf="noEntriesFoundLabel && value && _options?.length === 0"
										class="mat-select-search-no-entries-found">
										{{noEntriesFoundLabel}}</div> --> <!--Filter End  --> 
										
										<mat-option
											*ngFor="let apiDynamicAttribue of filteredDynamicAttribueMulti | async "
											[value]="apiDynamicAttribue">
										{{apiDynamicAttribue}} 
										</mat-option> 
										
										<!-- <mat-option *ngIf="shown.beforeFilter"
										*ngFor="let apiDynamicAttribue of apiDynamicAttribue"
										[value]="apiDynamicAttribue">
									    {{apiDynamicAttribue}} </mat-option> --> 
									
									</mat-select> 
									</mat-form-field>
									</div>
									
								</div>

							</div>
							<!--  -->
						</div>
					</div>

					<div class="col-md-12 col-sm-12 col-xs-12 col-lg-12" style="padding-left: 30px;">
						<button mat-raised-button class="btn"
							style="color: #fff; margin-right: 12px;" type="submit"
							value="submit">Submit</button>

						<button mat-raised-button class="btn"
							style="color: #fff; margin-right: 12px;"
							[routerLink]="['/apiManager']">Cancel</button>
						<!--  -->
					</div>
					</div>
				</div>
			</form>
			</mat-card>
			</div>


			<div class="col-md-6 col-sm-6 col-xs-6 col-lg-6">
				<mat-card class="apimanagerresultpanel"> 
				 <h4>Api Response</h4>
				<div class="loader">
				
				</div>
				<!-- Spinner End -->

				<div *ngIf="apiResponseData">
					<pre style="height: 70vh">
			{{apiResponseData |json }}</pre>
				</div>

				

				</mat-card>
			</div>
			<div style="float:right; margin-top: -2%;padding: 15px;">
			<button (click)= apiMappingSubmit()
					mat-flat-button class="btn">Proceed To ResponseMapping</button>
			</div>		
			
		</div>
	</div>
</div>